import React from 'react';
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider';
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography';
import Alert from 'housecall-ui/dist/DesignSystem/Feedback/Alert/Alert';
import Box from 'housecall-ui/dist/DesignSystem/Layout/Box/Box';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import AddShoppingCart from 'housecall-ui/dist/IconsAndImages/Icons/AddShoppingCart';

import HelpArticleLink from 'components/Common/HelpArticleLink';

import ECommerceButton from '../OtherComponents/ECommerceButton';

const ECommerceStrategy = {
  previewInfo: {
    name: 'E-commerce',
    iconSvg: <AddShoppingCart size="xlarge" color="primary" />,
    newTab: false,
  },
  headerInfo: {
    name: 'E-commerce',
    category: 'Productivity',
    details: (
      <>
        <Typography variant="body1" paragraph>
          Ordering and keeping track of material needed for jobs often requires several steps while juggling multiple
          platforms.
        </Typography>
        <Typography variant="body1" paragraph>
          Our E-commerce solution streamlines this process by allowing you to create purchase orders on a job, and shop
          for material from available vendors all within Housecall Pro.
        </Typography>
        <Alert severity="info">
          Carrier Enterprise is the only supported vendor at this time, but expect more vendors to be added soon!
        </Alert>
        <Box p={4} />
        <Divider />
        <Box p={3} />
        <Typography variant="subtitle1" paragraph>
          Want to learn more about how this solution works?
        </Typography>
        <Typography variant="body2" paragraph>
          Check out our{' '}
          <HelpArticleLink helpArticlePath="/en/articles/4973423-carrier-enterprise-purchase-orders">
            help guide
          </HelpArticleLink>{' '}
          for setting up E-commerce purchase orders.
        </Typography>
      </>
    ),
    iconSvg: <AddShoppingCart size="xlarge" color="primary" />,
  },
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    hideToggle: true,
    hideCard: true,
    appActionButton: <ECommerceButton />,
  },
  supportContacts: [],
};

export default ECommerceStrategy;
